<template>
    <div :class="[{'rightP':true,'rightSeckill':ite.discountTypes=='seckill','rightChange':ite.discountTypes=='change','rightSpell':ite.discountTypes=='spell','rightGive':ite.discountTypes=='give','rightMemberLevel':$store.state.memberLevel&&ite[getMemberLevel($store.state.memberLevel).memberLevel]}]"
        v-if="ite.discountTypes || $store.state.memberLevel&&ite[getMemberLevel($store.state.memberLevel).memberLevel]" v-show="seckillShow">
        <div class="rightContent">
            <span v-if="$store.state.memberLevel&&ite[getMemberLevel($store.state.memberLevel).memberLevel]">{{getMemberLevel($store.state.memberLevel).name}}：￥<span style="fontSize:16px;">{{ite[getMemberLevel($store.state.memberLevel).memberLevel]}}</span></span>
            <span v-if="ite.discountTypes=='seckill'">秒杀特惠：￥<span style="fontSize:16px;">{{ite.priceType}}</span></span>
            <span v-if="ite.discountTypes=='change'">换购特惠：￥<span style="fontSize:16px;">{{ite.changeData}}</span></span>
            <!-- 没件有赠 -->
            <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')==-1&&ite.spellData.indexOf('赠')>-1">满￥<span style="fontSize:16px;">{{ite.spellText}}</span>：赠<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
            <!-- 有件没赠 -->
            <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')>-1&&ite.spellData.indexOf('赠')==-1">满<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件：￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
            <!-- 没件没赠 -->
            <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')==-1&&ite.spellData.indexOf('赠')==-1">满￥<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>：￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
            <!-- 有件有赠 -->
            <span v-if="ite.discountTypes=='spell'&&ite.spellText.indexOf('件')>-1&&ite.spellData.indexOf('赠')>-1">满<span style="fontSize:16px;">{{ite.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件：赠￥<span style="fontSize:16px;">{{ite.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
            <!-- 有件 -->
            <span v-if="ite.discountTypes=='give'&&ite.giveText.indexOf('件')>-1">满<span style="fontSize:16px;">{{ite.giveText.match(/\d+(\.\d+)?/g)[0]}}</span>件：用￥<span style="fontSize:16px;">{{ite.giveData}}</span></span>
            <!-- 无件 -->
            <span v-if="ite.discountTypes=='give'&&ite.giveText.indexOf('件')==-1">满￥<span style="fontSize:16px;">{{ite.giveText}}</span>：用￥<span style="fontSize:16px;">{{ite.giveData}}</span></span>
        </div>
        <div class="rightContent">
            <span>距结束</span>
            <CountDown :endTime="ite.discountTypes?ite.endTime:($store.state.memberLevel&&ite[getMemberLevel($store.state.memberLevel).memberLevel]?ite.memberEndTime:'')"
                        :contentId="ite.contentId"
                        @removeCon="removeCon" />
        </div>
    </div>
</template>
<script>
import CountDown from "../components/CountDown.vue";
export default {
    name:'specialOffer',
    props:{
        ite:{
          type:Object,
          default:() => ({discountTypes:''})
        }
    },
    data(){
      return{
        seckillShow:true
      }
    },
    components:{
        CountDown
    },
    methods:{
        removeCon(id,tOrf){
            this.seckillShow = false;
            this.$emit('removeCon',id,tOrf);
        }
    }
}
</script>
<style lang="scss" scoped>
.rightP{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  border-radius: 0 0 0 46px;
  min-width: 130px;
  height: 46px;
  padding-left: 10px;
}
.rightSeckill {
  background: -webkit-linear-gradient(left, #ef7a41, #f33e33);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ef7a41, #f33e33);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ef7a41, #f33e33);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ef7a41, #f33e33);
}
.rightChange{
  background: -webkit-linear-gradient(left, #ff7ccb, #f92589);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ff7ccb, #f92589);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ff7ccb, #f92589);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ff7ccb, #f92589);
}
.rightSpell{
  background: -webkit-linear-gradient(left, #fcd071, #fc8237);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #fcd071, #fc8237);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #fcd071, #fc8237);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #fcd071, #fc8237);
}

.rightGive{
  background: -webkit-linear-gradient(left, #0fdee6, #1f8de9);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #0fdee6, #1f8de9);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #0fdee6, #1f8de9);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #0fdee6, #1f8de9);
}
.rightMemberLevel{
  background: -webkit-linear-gradient(left, #ef7a41, #f33e33);
  /*  Safari 5.1 到 6.0 */
  background: -o-linear-gradient(right, #ef7a41, #f33e33);
  /*  Opera 11.6 到 12.0 */
  background: -moz-linear-gradient(right, #ef7a41, #f33e33);
  /*  Fx 3.6 到 15 */
  background: linear-gradient(to right, #ef7a41, #f33e33);
}
.rightContent {
  line-height: 16px;
  text-align: right;
  padding: 4px 8px 0 0;
  span {
    font-size: 12px;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/specialOffer.vue